import { timeSpanFormatString } from 'owa-locstrings/lib/strings/timespanformatstring.locstring.json';
import loc, { format } from 'owa-localize';
import {
    owaDate,
    isSameDay,
    OwaDate,
    formatShortTime,
    formatWeekDayDate,
    formatWeekDayDateTime,
} from 'owa-datetime';

/**
 * Gets the text to show in the selected time in the scheduling grid
 * @param itemModel The item model with start, end and all day properties
 * @returns The formatted daterange text of the event, in the Start time zone.
 */
export default function getDurationText({
    Start,
    End,
    IsAllDayEvent,
}: {
    Start: OwaDate;
    End: OwaDate;
    IsAllDayEvent: boolean;
}): string {
    const sameDay = isSameDay(Start, End);

    // allDay, sameDay
    if (IsAllDayEvent && sameDay) {
        return formatWeekDayDate(Start);
    }

    const formatFunction = IsAllDayEvent
        ? formatWeekDayDate // allDay, !sameDay
        : sameDay
        ? formatShortTime // !allDay, sameDay
        : formatWeekDayDateTime; // !allDay, !sameDay

    // Format both dates in the same time zone
    const end = owaDate(Start.tz, End);
    return format(loc(timeSpanFormatString), formatFunction(Start), formatFunction(end));
}
